import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from '@services/navigation.service';
import { StorageService } from '@services/storage.service';

@Injectable({
  providedIn: 'root',
})
export class OrderAddressGuard {
  private router = inject(Router);
  private storageService = inject(StorageService);
  private navigationService = inject(NavigationService);

  /**
   * Determines if the order address page should be loaded.
   */
  public canActivate(): boolean {
    if (!this.storageService.addressComplete) {
      return true;
    }

    this.router.navigate([this.navigationService.getOrderAddressUrl()]);

    return false;
  }
}
